import { render } from "./BarLoader.vue?vue&type=template&id=4ce822b8&scoped=true"
import script from "./BarLoader.vue?vue&type=script&lang=js"
export * from "./BarLoader.vue?vue&type=script&lang=js"

import "./BarLoader.vue?vue&type=style&index=0&id=4ce822b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ce822b8"]])

export default __exports__